// Instrukcje urządzeń (PLAN-ZROWNANIA „Etap 6”, SPIS I-1): lista (instrukcje urządzeń konta na górze - liczy worker),
// instrukcja krokami, animacje SVG wstawiane do strony (kolory z motywu), zdjęcia; PDF - dokument HTML A4 (podgląd
// i druk do PDF w APP). Całą treść worker wydaje w języku konta - APP jej nie tłumaczy.
import type { ManualDocReply, ManualProgressIn, ManualReply, ManualsReply, OKReply } from "../gen/kontrakt";
import { plik, zapytanie, zObrazkamiZaplecza } from "./zaplecze";

const sciezka = (id: string) => "/api/instrukcje/" + encodeURIComponent(id);

export const instrukcje = () => zapytanie<ManualsReply>("GET", "/api/instrukcje");

export const instrukcja = (id: string) => zapytanie<ManualReply>("GET", sciezka(id));

/** Postęp czytania konta: bieżący krok (od 1) i rozdział przeczytany do końca (-1 = żaden). */
export const zapiszPostep = (id: string, krok: number, przeczytany: number) =>
  zapytanie<OKReply>("POST", sciezka(id) + "/postep", { krok, przeczytany } satisfies ManualProgressIn);

/** n-ty PDF instrukcji jako dokument HTML (obrazki kroków z zaplecza - w aplikacji ze sklepu jako blob). */
export const pdfInstrukcji = (id: string, n: number) =>
  zapytanie<ManualDocReply>("GET", sciezka(id) + "/pdf/" + n).then((d) => zObrazkamiZaplecza(d.html));

/** Adres zdjęcia kroku. */
export const adresMedium = (id: string, nazwa: string) => sciezka(id) + "/media/" + encodeURIComponent(nazwa);

const animacje = new Map<string, Promise<string>>();

/** Treść animacji SVG (raz na plik) - wstawiana do strony, żeby brała kolory motywu. */
export function animacja(id: string, nazwa: string): Promise<string> {
  let p = animacje.get(nazwa);
  if (!p) {
    p = plik(adresMedium(id, nazwa)).then((b) => new TextDecoder().decode(b));
    p.catch(() => animacje.delete(nazwa));
    animacje.set(nazwa, p);
  }
  return p;
}
